import * as Sentry from "@sentry/browser";

export async function subscribe(values, emailKey, variantID, newsletterKey) {
  const subscription = {
    variantID,
  };
  if (values[emailKey]) {
    subscription.email = values[emailKey];
  }

  const result = {
    success: false,
    message: "",
  };

  try {
    const response = await fetch("/api/klaviyo-waitlist", {
      body: JSON.stringify(subscription),
      method: "POST",
      headers: { Accept: "application/json" },
    });

    if (values[newsletterKey]) {
      fetch("/api/klaviyo-subscribe", {
        body: JSON.stringify(subscription),
        method: "POST",
        headers: { Accept: "application/json" },
      });
    }

    const waitlistResult = await response.json();

    if (response.ok) {
      result.success = true;
    } else if (waitlistResult && waitlistResult.body) {
      result.message = waitlistResult.body;
    } else {
      result.message = "An Error occurred! Could not subscribe";
    }
  } catch (error) {
    Sentry.captureException(error);
    result.message = error;
  }

  return result;
}
